import React, { useState, useRef, useEffect, memo } from 'react';
import './BioMercy.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// Import directly from features and shared to avoid circular dependency
import { Home } from '../features/home';
import { Catalogo } from '../features/catalogo';
import { NosotrosController } from '../features/nosotros';
import { MedicosAldia } from '../features/medicos';
import { Cobertura } from '../features/cobertura';
import { LineasProductos } from '../features/productos';
import { TopBanner } from '../features/home';
import {
  NavbarBioMercy,
  FooterBioMercy,
  PharmacovigilanceSection,
  FarmacoModal,
} from '../shared/navigation';
import {
  CertificacionBiomercy,
  DoctoresAlDia,
  InfoBiomercy,
} from '../shared/cards';
import { RegistroModal } from '../shared/modals';

const HomeMemo = memo(Home);
const CatalogoMemo = memo(Catalogo);
const MedicosAldiaMemo = memo(MedicosAldia);

const BioMercy = () => {
  const [vistaActual, setVistaActual] = useState('home');
  const [medicosActiveSection, setMedicosActiveSection] = useState('congresos');
  const [nosotrosActiveSection, setNosotrosActiveSection] = useState('quienes');
  const [showRegistroModal, setShowRegistroModal] = useState(false);
  const [showFarmacoModal, setShowFarmacoModal] = useState(false);

  // Refs para scrollear al inicio
  const nosotrosRef = useRef(null);
  const catalogoRef = useRef(null);

  // Hook para scroll al montar según vista
  useEffect(() => {
    const ref = vistaActual === 'catalogo' ? catalogoRef : nosotrosRef;
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [vistaActual]);

  // Función para manejar la navegación a nosotros DESDE CUALQUIER VISTA
  const handleNosotrosNavigation = (section = 'quienes') => {
    setNosotrosActiveSection(section);
    setVistaActual('nosotros');
    setNosotrosActiveSection(`${section}-${Date.now()}`);
  };

  const renderView = () => {
    switch (vistaActual) {
      case 'home':
        return (
          <div>
            <HomeMemo />
            <InfoBiomercy
              onVerQuienesSomos={() => handleNosotrosNavigation('quienes')}
            />
            <LineasProductos onVerCatalogo={() => setVistaActual('catalogo')} />
            <Cobertura />
            <DoctoresAlDia
              onVerQuienesSomos={() => handleNosotrosNavigation('quienes')}
            />
            <CertificacionBiomercy />
            <PharmacovigilanceSection />
            <FooterBioMercy />
          </div>
        );
      case 'catalogo':
        return (
          <div ref={catalogoRef} className="catalogo-section">
            <CatalogoMemo />
            <Cobertura />
            <PharmacovigilanceSection />
            <FooterBioMercy />
          </div>
        );
      case 'nosotros':
        return (
          <div ref={nosotrosRef}>
            <NosotrosController
              key={`nosotros-${nosotrosActiveSection}`}
              initialSection={nosotrosActiveSection.split('-')[0]}
            />
            <PharmacovigilanceSection />
            <FooterBioMercy />
          </div>
        );
      case 'medicos':
        return (
          <div>
            <MedicosAldiaMemo activeSection={medicosActiveSection} />
            <PharmacovigilanceSection />
            <FooterBioMercy />
          </div>
        );
      default:
        return null;
    }
  };

  const backgroundImageUrl = `${process.env.PUBLIC_URL || ''}/assets/FONDO WEB.gif`;

  return (
    <div
      className="biomercy-container"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      <NavbarBioMercy
        onVerCatalogo={() => setVistaActual('catalogo')}
        onVerQuienesSomos={handleNosotrosNavigation}
        onVerMedicos={(section = 'congresos') => {
          setVistaActual('medicos');
          setMedicosActiveSection(section);
        }}
        onCerrarCatalogo={() => setVistaActual('home')}
        onAbrirRegistro={() => setShowRegistroModal(true)}
        onAbrirFarmacoModal={() => setShowFarmacoModal(true)}
      />

      <TopBanner theme={vistaActual} />

      <RegistroModal
        isOpen={showRegistroModal}
        onClose={() => setShowRegistroModal(false)}
      />
      <FarmacoModal
        visible={showFarmacoModal}
        onClose={() => setShowFarmacoModal(false)}
      />

      {renderView()}
    </div>
  );
};

export default memo(BioMercy);
